import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import { ClassMembership } from '../class-membership.js';
import { Teacher } from '../teacher.js';

/**
 * All of the current teacher's pending join requests, across every one of their classes — the
 * client groups these by `classRoomID` to render a per-class pending-count badge. This is also
 * the poll-on-page-open source for the teacher's "new join request" notification (see plan: no
 * real-time watcher/subscription for v1).
 */
export const getPendingRequestCountsQuery = registerQuery({
  operationName: 'getPendingRequestCountsQuery',
  type: () => [ClassMembership],
  params: [],

  resolve: () => async (_gqlFields: BaseQLSelectionSet<ClassMembership>): Promise<ClassMembership[]> => {
    const currentUser = await CurrentUserInfo.getMyself()({ _id: 1 });
    if (!currentUser?._id) return [];

    const teacherCollection = await getCollection(Teacher);
    const teacher = await teacherCollection.findOne({ userID: currentUser._id });
    if (!teacher) return [];

    const membershipCollection = await getCollection(ClassMembership);
    const memberships = await membershipCollection.find({ teacherID: teacher._id, status: 'pending' }).toArray();

    return memberships as ClassMembership[];
  },
});
